export function getFavouriteMatchesFromStorage() {
	return JSON.parse(localStorage.getItem('x_fav_mtchs') || '{}');
}
